import "./component.css";
import logo from "../../../assets/images/shelflogo.png";
import { Icon } from "@iconify/react";
import powerby from "../../../assets/images/powerby.png";
import { useUserState } from "../../../context/UserContext";
const Preview = ({ Title, Body }) => {
  const { appLogo } = useUserState();

  return (
    <div className="preview">
      <div className="main_preview">
        <div className="header">
          <p>
            <b>{Title}</b>
          </p>
          <img src={appLogo || logo} alt="Logo" className="preview_logo" />
        </div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: Body }}
        />
        <p style={{ marginTop: 0 }}>Need Help</p>
        <p>Please send any feedback or complaints you may have to support@shelf21.com</p>
        <p>Unsubscribe from our email list here.</p>
        <div className="footer">
          <div className="icon">
            <div>
              <Icon icon="mdi:facebook" width="24" height="24" />
            </div>
            <div>
              <Icon icon="mdi:instagram" width="24" height="24" />
            </div>
            <div>
              <Icon icon="mdi:twitter" width="24" height="24" />
            </div>
          </div>
          <img src={powerby} alt="Powered By" />
        </div>
      </div>
    </div>
  );
};

export default Preview;
